import { PropsWithChildren } from 'react';

import { SimpleGrid, SimpleGridProps } from '@chakra-ui/react';

export function LegalSectionGrid(props: PropsWithChildren<SimpleGridProps>) {
  const { children, ...simpleGridProps } = props;

  return (
    <SimpleGrid
      columnGap='40px'
      columns={{ base: 1, md: 3, lg: 4 }}
      spacing={{ base: '16px', lg: '24px' }}
      {...simpleGridProps}
    >
      {children}
    </SimpleGrid>
  );
}
